const VENUE_CONSTRAINTS = {
  NAME: {
    MIN_LENGTH: 1,
    MAX_LENGTH: 50
  }
};

export { VENUE_CONSTRAINTS };
